var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list__info list-info employee-edit-form"},[_c('v-employee-form',{on:{"submit":_vm.onUserAdd}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }